import styled from 'styled-components';

import { GooglePass } from 'components/google-pass';
import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

import { RewardsManagement } from '../../rewards-management';

export const RewardsTitleContainer = styled.div`
  width: 100%;
  padding: ${primitive.$spacing4} 0;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font: ${brandFont.headerThree};
  line-height: inherit;
  color: ${({ theme }) => theme.token('text-default')};
`;

export const RewardPoints = styled.div`
  color: ${primitive.th.$coffeeBrown};
  font-size: 1.25rem;
`;

export const ImageContainer = styled.div`
  height: 24px;
  flex: 1;
  & > div > img {
    width: unset !important;
    max-width: 100% !important;
  }
`;

export const StyledRewardsManagement = styled(RewardsManagement)`
  width: 100%;
`;

export const QRCodeContainer = styled.div`
  border-radius: 10px;
  background: white;
  padding: 2px;
  display: flex;
`;

export const QRCodeWrapper = styled.div`
  position: relative;
  border-radius: 6px;
  background: white;
  display: flex;
`;

export const CardNumber = styled.p`
  font-weight: ${Styles.fontWeight.heavy};
  color: ${primitive.th.$coffeeBrown};
  margin: 0;
`;

export const PassWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: ${primitive.$spacing4} 0;
`;

export const StyledGooglePass = styled(GooglePass)`
  position: relative;
  left: 10px;
`;
